import { Progress } from "@/components/ui/progress";

export function UsageLimitBar({ label, used, limit }: { label: string; used: number; limit?: number | null }) {
  const percent = limit ? Math.min(100, Math.round((used / limit) * 100)) : 0;
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">{label}</span>
        <span className="font-medium text-foreground">{used.toLocaleString()} / {limit == null ? "Custom" : limit.toLocaleString()}</span>
      </div>
      <Progress value={limit == null ? 100 : percent} className="h-2" />
    </div>
  );
}
